import React from 'react'
import { FormSelect } from '@myxplor/forms/build/main'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import RaFields from './ra-fields'
import OaFields from './oa-fields'
import CwaFields from './cwa-fields'
import PeaFields from './pea-fields'
import { updateSubmitValues } from './enrolment-booking-schedule'

const available = child => hasAvailableAction(child, 'create_ccs_enrolment')

const apiEndPoint = (regHolderId, regHolderType, childId) =>
  `/api/${regHolderType}/${regHolderId}/children/${childId}`

const defaultValues = arrangement_type => ({
  arrangement_type: arrangement_type,
  enrolment_params: {},
})

const options = [
  { value: 'CWA', label: 'Complying Written Arrangement (CWA)' },
  { value: 'RA', label: 'Relevant Arrangement (RA)' },
  { value: 'OA', label: 'Organisation Arrangement (OA)' },
  { value: 'PEA', label: 'Child Wellbeing - Provider Eligible Arrangement' }
]

const onArrangementTypeChange = props => (key, arrangement_type) => {
  props.resetForm(defaultValues(arrangement_type))
}

const FormComponent = props => {
  const { addKey, errorAtKey, removeKey, values, errors, onChange, baseEndpoint } = props
  return (
    <fieldset>
      <FormSelect
        name='arrangement_type'
        label='What type of Enrolment would you like to create?'
        onChange={onArrangementTypeChange(props)}
        value={values.arrangement_type}
        placeholder='Please select ...'
        options={options}
        errors={errors.arrangement_type}
        required
        compact
      />

      {values.arrangement_type === 'RA' && (
        <RaFields
          values={values}
          errors={errors}
          onChange={onChange}
          baseEndpoint={baseEndpoint}
        />
      )}

      {values.arrangement_type === 'CWA' && (
        <CwaFields
          values={values}
          errors={errors}
          onChange={onChange}
          baseEndpoint={baseEndpoint}
          addKey={addKey}
          removeKey={removeKey}
        />
      )}

      {values.arrangement_type === 'PEA' && (
        <PeaFields
          values={values}
          errors={errors}
          onChange={onChange}
          addKey={addKey}
          errorAtKey={errorAtKey}
          removeKey={removeKey}
          baseEndpoint={baseEndpoint}
        />
      )}

      {values.arrangement_type === 'OA' && (
        <OaFields
          values={values}
          errors={errors}
          onChange={onChange}
          baseEndpoint={baseEndpoint}
        />
      )}
    </fieldset>
  )
}

const hasEnrolmentSchedule = ({ arrangement_type }) =>
 arrangement_type === 'PEA' || arrangement_type === 'CWA'

const calculateSubmitValues = values =>
  hasEnrolmentSchedule(values) ? updateSubmitValues(values) : values

const formValue = 'arrangement_type'

const actionForm = ({ baseEndpoint }) => ({ handleSuccess }) => (
  <DefaultForm
    url={process.env.REACT_APP_API_HOST + baseEndpoint + '/ccs-enrolments'}
    name={formValue}
    label="Create"
    calculateSubmitValues={calculateSubmitValues}
    handleSuccess={() =>
      handleSuccess({ [formValue]: 'CCS Enrolment has been created.' }, formValue)
    }
    formOptions={{ defaultValues: defaultValues(options[0].value) }}
    formComponent={props => <FormComponent {...props} baseEndpoint={baseEndpoint} />}
  />
)

export const createCCSEnrolment = ({ regHolderId, regHolderType, child, refresh_enrolments }) =>
  available(child)
    ? {
      label: 'New CCS Enrolment',
      value: 'arrangement_type',
      actionForm: actionForm({
        baseEndpoint: apiEndPoint(regHolderId, regHolderType, child.id),
      }),
      onComplete: refresh_enrolments,
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/index.js